import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import API_URL from '../../api/baseURL'; 

export default function PartValidations() {
  const { token } = useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${API_URL}/admin/ai-part-validations`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        setLogs(data);
        setLoading(false);
      });
  }, [token]);

  const handleAction = async (id, action) => {
    await fetch(`${API_URL}/admin/ai-part-validations/${id}/${action}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` }
    });
    setLogs(logs =>
      logs.map(l =>
        l._id === id ? { ...l, status: action === "approve" ? "approved" : "rejected" } : l
      )
    );
  };

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">AI Part Validations</h1>
      <table className="min-w-full bg-gray-900 text-white rounded text-xs">
        <thead>
          <tr>
            <th className="p-2">Part</th>
            <th className="p-2">Brand</th>
            <th className="p-2">Reference</th>
            <th className="p-2">Supplier</th>
            <th className="p-2">Status</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(log => (
            <tr key={log._id}>
              <td className="p-2">{log.partName}</td>
              <td className="p-2">{log.brand}</td>
              <td className="p-2">{log.reference}</td>
              <td className="p-2">{log.supplierName}</td>
              <td className="p-2">
                <span
                  className={
                    log.status === "pending"
                      ? "text-yellow-400"
                      : log.status === "approved"
                      ? "text-green-400"
                      : "text-red-400"
                  }
                >
                  {log.status}
                </span>
              </td>
              <td className="p-2">
                {log.status === "pending" && (
                  <>
                    <button
                      className="bg-green-700 text-white px-2 py-1 rounded mr-2"
                      onClick={() => handleAction(log._id, "approve")}
                    >
                      Approve
                    </button>
                    <button
                      className="bg-red-700 text-white px-2 py-1 rounded"
                      onClick={() => handleAction(log._id, "reject")}
                    >
                      Reject
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
